import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import StaticMap from './StaticMap.js';
import NonStaticMap from './NonStaticMap.js';

import Loading from './Loading.js';

/**
 * 
 * 
 * @param lat - Required parameter, will place marker on the map if present. Pass "inhibitMarker={true}" to stop this behaviour
 * @param lng - Required parameter, will place marker on the map if present. Pass "inhibitMarker={true}" to stop this behaviour
 */
function MapViewHeaderComponent({ children, isLoading = false, lat, lng, noDefaultMarker = false, zoom, label, geoJSON, alertGeoJSON, isStatic = true, overrideHeight, additionalCustomGeoJSON}) {

	let height = "220px";
	if(overrideHeight) {
		height = overrideHeight;
	}

	return <div>
		<Row>
			{isStatic && <Col xs={12} className="g-0">
				{isLoading ? <div style={{ height: height, width: '100%' }}><Loading /></div> : <StaticMap zoom={zoom} style={{ height: height, width: '100%' }} noDefaultMarker={noDefaultMarker} lat={lat} lng={lng} label={label} geoJSON={geoJSON} alertGeoJSON={alertGeoJSON} additionalCustomGeoJSON={additionalCustomGeoJSON}>
					{children}
				</StaticMap>}
			</Col>}
			{!isStatic && <Col xs={12} className="g-0">
				{isLoading ? <div style={{ height: height, width: '100%' }}><Loading /></div> : <NonStaticMap zoom={zoom} style={{ height: height, width: '100%' }} noDefaultMarker={noDefaultMarker} lat={lat} lng={lng} label={label} geoJSON={geoJSON} alertGeoJSON={alertGeoJSON} additionalCustomGeoJSON={additionalCustomGeoJSON}>
					{children}
				</NonStaticMap>}
			</Col>}
		</Row>
		<Row>
			<Col className="bg-dark text-white" style={{marginBottom: "4px", paddingBottom: "2px"}} xs={12}><h1 className="h1-blendin header-bold">{isLoading ? 'Loading Station Data' : label}</h1></Col>
		</Row>
	</div>
}

export default MapViewHeaderComponent;